import { render, staticRenderFns } from "./last.vue?vue&type=template&id=c448161c"
import script from "./last.vue?vue&type=script&lang=js"
export * from "./last.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports